<style>
.user table  tr th{
  text-align: center;
}
.user table  td:nth-child(1){
  text-align: center;
}
</style>
<template>
  <div class="dynamic-tables">
    <Widget title="<h4>User</h4>" collapse close customHeader>
      <div class="form-group row">
        <div class="col-sm-6">
          <b-button variant="success" v-b-modal.modal-tambah><span class="glyphicon glyphicon-plus mb-2" /> Tambah
          </b-button>
        </div>
        <div class="col-sm-6 text-end">
        </div>
      </div>
      <div class="user">
        <v-client-table :data="itemsWithNumber" :columns="columnsDatatable" :options="optionsUsers">
          <div slot="aksi" slot-scope="props">
            <b-button variant="info" class="me-3" size="s" @click="getDetail(props.row.id)">
              <i class="glyphicon glyphicon-pencil text-white me-sm-1 mb-sm-2" />
              <span class="d-none d-md-inline-block text-white">Edit</span>
            </b-button>
            <b-button variant="warning" class="me-3" size="s" @click="getDetailPassword(props.row.id)">
              <i class="glyphicon glyphicon-pencil text-white me-sm-1 mb-sm-2" />
              <span class="d-none d-md-inline-block text-white">Edit Password</span>
            </b-button>
            <b-button style="margin-left:5px" class="me-3" size="s" variant="danger" @click="deleteData(props.row.id)">
              <i class="glyphicon glyphicon-trash text-white me-sm-1 mb-sm-2" />
              <span class="d-none d-md-inline-block text-white">Delete</span>
            </b-button>

          </div>
        </v-client-table>
      </div>
    </Widget>

    <!-- modal tambah -->
    <b-modal body-class="bg-white" id="modal-tambah" scrollable title="Tambah Data" cancel-title="Close"
      ok-title="Accept" cancel-variant="outline-secondary" size="lg">
      <form ref="form" @submit.stop.prevent="tambahdata">
        <b-row>
          <b-col md="6">
            <b-form-group label="Nama" label-for="name" class="mb-3">
              <b-form-input v-validate="'required'" name="nama"
                :class="{ 'form-control': true, 'is-invalid': errors.has('nama') }" id="name"
                v-model="dataPengguna.nama" />
              <span class="text-danger" v-if="errors.has('nama')">
                {{ errors.first('nama') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Email" label-for="email" class="mb-3">
              <b-form-input v-validate="'required|email'" name="email"
                :class="{ 'form-control': true, 'is-invalid': errors.has('email') }" id="email"
                v-model="dataPengguna.email" type="email" />
              <span class="text-danger" v-if="errors.has('email')">
                {{ errors.first('email') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Password" label-for="email" class="mb-3">
              <b-form-input id="email" v-model="dataPengguna.password" type="password" v-validate="'required'"
                name="password" :class="{ 'form-control': true, 'is-invalid': errors.has('password') }" />
              <span class="text-danger" v-if="errors.has('password')">
                {{ errors.first('password') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <!-- Hak Akses -->
            <b-form-group label="Role" label-for="register-kecamatan">
              <b-form-select class="form-control" v-validate="'required'" name="role"
                :class="{ 'form-control': true, 'is-invalid': errors.has('role') }" v-model="dataPengguna.role">
                <option v-for="(dataRole, k) in dataRole" :key="k" :value="dataRole.name">
                  {{ dataRole.name }}
                </option>
              </b-form-select>
              <span class="text-danger" v-if="errors.has('role')">
                {{ errors.first('role') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="NIP" label-for="name" class="mb-3">
              <b-form-input v-validate="'required'" name="nip"
                :class="{ 'form-control': true, 'is-invalid': errors.has('nip') }" id="name"
                v-model="dataPengguna.nip"/>
              <span class="text-danger" v-if="errors.has('nip')">
                {{ errors.first('nip') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Golongan" label-for="name" class="mb-3">
              <b-form-input v-validate="'required'" name="golongan"
                :class="{ 'form-control': true, 'is-invalid': errors.has('golongan') }" id="name"
                v-model="dataPengguna.golongan"/>
              <span class="text-danger" v-if="errors.has('golongan')">
                {{ errors.first('golongan') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="No Hp" label-for="name" class="mb-3">
              <b-form-input v-validate="'required'" name="no_hp"
                :class="{ 'form-control': true, 'is-invalid': errors.has('no_hp') }" id="name"
                v-model="dataPengguna.no_hp" oninput="this.value = this.value.replace(/[^0-9]/g, '')" />
              <span class="text-danger" v-if="errors.has('no_hp')">
                {{ errors.first('no_hp') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Provinsi" label-for="name" class="mb-3">
              <v-select v-model="dataPengguna.kode_provinsi" :options="dataProvinsi" :reduce="provinsi => provinsi.id" label="nama_provinsi" />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Alamat" label-for="alamat" class="mb-3">
              <b-form-textarea name="alamat" :class="{ 'form-control': true, 'is-invalid': errors.has('alamat') }"
                id="textarea" v-model="text" placeholder="Enter something..." rows="3" max-rows="6"
                v-validate="'required'"></b-form-textarea>
              <span class="text-danger" v-if="errors.has('alamat')">
                {{ errors.first('alamat') }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>

      </form>


      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="onSubmit">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
            
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal tambah -->
    <b-modal body-class="bg-white" id="modal-edit" scrollable title="Edit Data" cancel-title="Close" ok-title="Accept"
      cancel-variant="outline-secondary" size="lg">
      <form ref="form" @submit.stop.prevent="tambahdata">
        <b-row>
          <b-col md="6">
            <b-form-group label="Nama" label-for="name" class="mb-3">
              <b-form-input v-validate="'required'" name="nama"
                :class="{ 'form-control': true, 'is-invalid': errors.has('nama') }" id="name"
                v-model="dataPengguna.nama" />
              <span class="text-danger" v-if="errors.has('nama')">
                {{ errors.first('nama') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Email" label-for="email" class="mb-3">
              <b-form-input v-validate="'required|email'" name="email"
                :class="{ 'form-control': true, 'is-invalid': errors.has('email') }" id="email"
                v-model="dataPengguna.email" type="email" />
              <span class="text-danger" v-if="errors.has('email')">
                {{ errors.first('email') }}
              </span>
            </b-form-group>
          </b-col>

          

          <b-col md="6">
            <!-- Hak Akses -->
            <b-form-group label="Role" label-for="register-kecamatan">
              <b-form-select class="form-control" v-validate="'required'" name="role"
                :class="{ 'form-control': true, 'is-invalid': errors.has('role') }" v-model="dataPengguna.role">
                <option v-for="(dataRole, k) in dataRole" :key="k" :value="dataRole.name">
                  {{ dataRole.name }}
                </option>
              </b-form-select>
              <span class="text-danger" v-if="errors.has('role')">
                {{ errors.first('role') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="NIP" label-for="name" class="mb-3">
              <b-form-input v-validate="'required'" name="nip"
                :class="{ 'form-control': true, 'is-invalid': errors.has('nip') }" id="name"
                v-model="dataPengguna.nip"/>
              <span class="text-danger" v-if="errors.has('nip')">
                {{ errors.first('nip') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Golongan" label-for="name" class="mb-3">
              <b-form-input v-validate="'required'" name="golongan"
                :class="{ 'form-control': true, 'is-invalid': errors.has('golongan') }" id="name"
                v-model="dataPengguna.golongan"/>
              <span class="text-danger" v-if="errors.has('golongan')">
                {{ errors.first('golongan') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="No Hp" label-for="name" class="mb-3">
              <b-form-input v-validate="'required'" name="no_hp"
                :class="{ 'form-control': true, 'is-invalid': errors.has('no_hp') }" id="name"
                v-model="dataPengguna.no_hp" oninput="this.value = this.value.replace(/[^0-9]/g, '')" />
              <span class="text-danger" v-if="errors.has('no_hp')">
                {{ errors.first('no_hp') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Provinsi" label-for="name" class="mb-3">
              <v-select v-model="dataPengguna.kode_provinsi" :options="dataProvinsi" :reduce="provinsi => provinsi.id" label="nama_provinsi" />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Alamat" label-for="alamat" class="mb-3">
              <b-form-textarea name="alamat" :class="{ 'form-control': true, 'is-invalid': errors.has('alamat') }"
                id="textarea" v-model="text" placeholder="Enter something..." rows="3" max-rows="6"
                v-validate="'required'"></b-form-textarea>
              <span class="text-danger" v-if="errors.has('alamat')">
                {{ errors.first('alamat') }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>

      </form>


      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="editData(dataPengguna.id)">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
            
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal Ubah Password -->
    <b-modal body-class="bg-white" id="modal-edit-password" title="Edit Password" cancel-title="Close" ok-title="Accept"
      cancel-variant="outline-secondary" size="md">
      <form ref="form" @submit.stop.prevent="ubah_password">
        <b-row>
          <b-col md="6">
            <b-form-group label="Nama" label-for="name" class="mb-3">
              <b-form-input disabled v-validate="'required'" name="nama"
                :class="{ 'form-control': true, 'is-invalid': errors.has('nama') }" id="name"
                v-model="dataPengguna.nama" />
              <span class="text-danger" v-if="errors.has('nama')">
                {{ errors.first('nama') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Email" label-for="email" class="mb-3">
              <b-form-input disabled d v-validate="'required|email'" name="email"
                :class="{ 'form-control': true, 'is-invalid': errors.has('email') }" id="email"
                v-model="dataPengguna.email" type="email" />
              <span class="text-danger" v-if="errors.has('email')">
                {{ errors.first('email') }}
              </span>
            </b-form-group>
          </b-col>

      
          <b-col md="12">
            <b-form-group label="Ubah Password" label-for="password" class="mb-3">
              <b-form-input v-validate="'required'" name="password"
                :class="{ 'form-control': true, 'is-invalid': errors.has('password') }" id="password"
                v-model="new_password"/>
              <span class="text-danger" v-if="errors.has('password')">
                {{ errors.first('password') }}
              </span>
            </b-form-group>
          </b-col>

         
        </b-row>

      </form>


      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="editPassword(dataPengguna.id)">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
            
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
  
<script>
import Widget from '@/components/Widget/Widget';
import axios from 'axios';
import Swal from 'sweetalert2'
import vSelect from 'vue-select';

export default {
  name: 'Dynamic',
  components: { Widget, vSelect },
  data() {
    return {
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem('user')),
      columnsDatatable: ['no','nama', 'email', 'role', 'aksi'],
      dataUser: [],
      dataPengguna: [],
      dataRole: [],
      optionsUsers: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: '', count: '', limit: '' },
        columnsClasses: { no: 'width-100' },
        skin: 'table table-striped',
        sortIcon: {
          base: 'fa text-muted', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort',
        },
      },
      dataJabatan: [],
      dataProvinsi: [],
      new_password: null
    };
  },
  computed: {
    itemsWithNumber() {
      return this.dataUser.map((d, index) => ({ ...d, no: index + 1 }))
    }
  },
  mounted() {
    this.loaddata()
    this.getRole()
    this.getJabatan()
    this.getProvinsi()
  },
  methods: {
    deleteData(id) {
      Swal.fire({
        title: 'Hapus Data?',
        // text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya'
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(
              this.baseapi + `api/user/` + id,
              {
                headers: {
                  Authorization: `Bearer ` + this.user.accessToken
                }
              }
            )
            .then((res) => {
              this.$toasted.success("Berhasil Dihapus");
              this.loaddata()
              return res;
            })
            .catch((err) => {
              console.log(err)
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      })
    },
    onSubmit(e) {
      e.preventDefault();
      this.$validator.validateAll();
      // let formData = new FormData();
      // formData.append('nama', this.dataPengguna.nama);
      // formData.append('email', this.dataPengguna.email);
      // formData.append('role', this.dataPengguna.role);
      // formData.append('no_hp', this.dataPengguna.no_hp);
      // formData.append('alamat', this.dataPengguna.alamat);
      // formData.append('password', this.dataPengguna.password);
      axios
        .post(this.baseapi + 'api/user', {
          nama: this.dataPengguna.nama,
          email: this.dataPengguna.email,
          role: this.dataPengguna.role,
          no_hp: this.dataPengguna.no_hp,
          alamat: this.dataPengguna.alamat,
          password: this.dataPengguna.password,
          kode_provinsi: this.dataPengguna.kode_provinsi,
          nip: this.dataPengguna.nip,
          golongan: this.dataPengguna.golongan,
          jabatan: this.dataPengguna.jabatan

        },{
          headers: {
            // 'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ` + this.user.accessToken
          }
        })
        .then((res) => {
          this.$toasted.success("Berhasil Ditambah");
          this.loaddata()
          this.dataPengguna = []
          return res;
        })
        .catch((err) => {
          console.log(err)
          this.$toasted.error(err.response.data.message);
          return err;
        });

      // Wait until the models are updated in the UI
      this.$nextTick(() => {
        this.$bvModal.hide('modal-tambah')
      });
    },

    editData(id) {
      this.$validator.validateAll();
      axios
        .post(this.baseapi + 'api/user/'+ id, {
          nama: this.dataPengguna.nama,
          email: this.dataPengguna.email,
          role: this.dataPengguna.role,
          no_hp: this.dataPengguna.no_hp,
          alamat: this.dataPengguna.alamat,
          kode_provinsi: this.dataPengguna.kode_provinsi,
          nip: this.dataPengguna.nip,
          golongan: this.dataPengguna.golongan,
          jabatan: this.dataPengguna.jabatan

        },{
          headers: {
            // 'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ` + this.user.accessToken
          }
        })
        .then((res) => {
          this.$toasted.success("Berhasil Dubah");
          this.loaddata()
          this.dataPengguna = []
          return res;
        })
        .catch((err) => {
          console.log(err)
          this.$toasted.error(err.response.data.message);
          return err;
        });

      // Wait until the models are updated in the UI
      this.$nextTick(() => {
        this.$bvModal.hide('modal-edit')
      });
    },
    editPassword(id) {
      this.$validator.validateAll();
      axios
        .post(this.baseapi + 'api/user/'+ id, {
          password: this.new_password,

        },{
          headers: {
            // 'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ` + this.user.accessToken
          }
        })
        .then((res) => {
          this.$toasted.success("Berhasil Dubah");
          this.loaddata()
          this.dataPengguna = []
          this.new_password = null
          return res;
        })
        .catch((err) => {
          console.log(err)
          this.$toasted.error(err.response.data.message);
          return err;
        });

      // Wait until the models are updated in the UI
      this.$nextTick(() => {
        this.$bvModal.hide('modal-edit-password')
      });
    },

    getRole() {
      axios.get(this.baseapi + "api/role", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataRole = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    getJabatan() {
      axios.get(this.baseapi + "api/jabatan", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataJabatan = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    getProvinsi() {
      axios.get(this.baseapi + "api/provinsi", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataProvinsi = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    // loaddata user
    loaddata() {
      axios.get(this.baseapi + "api/user", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataUser = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    // detail
    getDetail(id) {
      axios.get(this.baseapi + "api/user/" + id, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataPengguna = response.data.data;
        this.$nextTick(() => {
          this.$bvModal.show('modal-edit')
        });
      }).catch(error => {
        console.log(error)
        return error
      });
    },
    getDetailPassword(id) {
      axios.get(this.baseapi + "api/user/" + id, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataPengguna = response.data.data;
        this.$nextTick(() => {
          this.$bvModal.show('modal-edit-password')
        });
      }).catch(error => {
        console.log(error)
        return error
      });
    }
  },
};
</script>
  
  

<style src="./User.scss" lang="scss" />
  